/**
 * 数字格式化
 * 0 - 999
 * 1k - 999k
 * 1M - 999M
 * @param {number} timestamp 时间戳
 */
export const formatNumber = (num: number) => {
  let unit = "";
  let retNum: string | number = "-";

  if (num >= 1000000) {
    unit = "m";
    retNum = num / 1000000;
  } else if (num >= 1000) {
    unit = "k";
    retNum = num / 1000;
  } else if (num >= 0) {
    retNum = num;
  }

  // 保留1位小数，不四舍五入
  retNum = (Math.floor(Number(retNum) * 10) / 10).toFixed(1);

  retNum = retNum.split(".")[1] === "0" ? retNum.split(".")[0] : retNum;

  return retNum + unit;
};

/**
 * 格式化书简介，按词的个数截断
 * @param {*} desc
 * @param {*} format
 * @param {*} wCount 词的个数
 * @param {*} suffix
 * @returns
 */
export function formatBookDescByWordCount(
  desc = "",
  format = false,
  wCount: number = 0,
  suffix = ""
) {
  const formatTxt = format ? desc.replace(/(\n|\r)+/g, "") : desc;
  const afterSplit = formatTxt.split(" ");
  const wordCount = afterSplit.length;
  let count = 0;
  let str = formatTxt;

  if (wCount) {
    str = "";
    for (let i = 0; i < wordCount; i++) {
      if (count >= wCount) {
        break;
      }
      str += ` ${afterSplit[i]}`;
      count += 1;
    }
    str = str.substring(1);
  }

  return str + (wCount && count < wordCount ? suffix : "");
}

// 多人字词，设置首字母大写
export const toUpperCaseWords = (words: string) => {
  if (!words) {
    return "";
  }
  return words.toLowerCase().replace(/\b(\w)/g, (char) => {
    return char.toUpperCase();
  });
};
